import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Search } from 'lucide-vue-next';

export default /*@__PURE__*/_defineComponent({
  __name: 'SearchIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Search)))
}
}

})